// NIR (numéro de sécurité sociale) : 13 chiffres + clé optionnelle de 2 chiffres, 2A/2B acceptés (Corse)
const NIR_REGEX = /^[12]\d{2}(0\d|1[0-2]|[2-9]\d)(\d{2}|2[AB])\d{3}\d{3}(\d{2})?$/;

// Enlève les espaces et met en majuscules (pour 2a/2b)
export function normalizeNIR(value) {
	return (value || "").replace(/\s+/g, "").toUpperCase();
}

export function isValidNIR(value) {
	return NIR_REGEX.test(normalizeNIR(value));
}

// Formate au fil de la saisie en groupes : 1 85 05 78 006 084 36
export function formatNIR(value) {
	const raw = normalizeNIR(value).replace(/[^0-9AB]/g, "").slice(0, 15);
	const groups = [1, 2, 2, 2, 3, 3, 2];
	const parts = [];
	let i = 0;

	for (const len of groups) {
		if (i >= raw.length)
			break;
		parts.push(raw.slice(i, i + len));
		i += len;
	}

	return parts.join(" ");
}
